export const authStorage: Storage = localStorage;